// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1IcAW","info":"PatientInfo_info__1bkWL"};